import { render, staticRenderFns } from "./BioSearchInput.vue?vue&type=template&id=c4aec4ee&scoped=true&"
import script from "./BioSearchInput.vue?vue&type=script&lang=js&"
export * from "./BioSearchInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4aec4ee",
  null
  
)

export default component.exports